import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

//Calendar
import calendar from "./calendar/reducer"

//chat
import chat from "./chat/reducer"

//dashboard
import Dashboard from "./dashboard/reducer";
import UserReducer from "./user/reducer"
import RegionReducer from "./regions/reducer"
import BusinessReducer from "./business/reducer"
import RolesReducer from "./role/reducer"
import LogoReducer from "./logo/reducer"
import StyleReducer from "./style/reducer"
import TemplateReducer from "./templates/reducer"
import SectionReducer from "./sections/reducer"
import SnippetsReducer from "./snippets/reducer"
import FilterBarReducer from "./filterBar/reducer"
import DocumentReducer from "./documents/reducer"
import WorkflowReducer from "./workflow/reducer"
import DocumentCenterReducer from "./documentCenter/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  calendar,
  chat,
  Dashboard,
  RolesReducer,
  UserReducer,
  BusinessReducer,
  RegionReducer,
  LogoReducer,
  StyleReducer,
  TemplateReducer,
  SectionReducer,
  SnippetsReducer,
  FilterBarReducer,
  DocumentReducer,
  WorkflowReducer,
  DocumentCenterReducer,
})

export default rootReducer
